module.exports = __webpack_public_path__ + "../resources/img/pin_code_info.ee675b67.png";